import { CitySelectInput } from "@/components/selects/CitySelectInput";
import { LocationSelectInput } from "@/components/selects/LocationSelectInput/LocationSelectInput";
import { Create, required, SimpleForm } from "react-admin";
import { useWatch } from "react-hook-form";

const LocationFormContent = () => {
  const cityId = useWatch({ name: "city_id" }); // Now this is in the correct context

  return (
    <>
      <CitySelectInput
        source="city_id"
        label="Select a City"
        validate={[required()]}
      />
      <LocationSelectInput
        source="location_id"
        label="Select a Location"
        cityId={cityId}
        isRequired={true}
      />
    </>
  );
};

const LocationCreate = () => {
  return (
    <Create>
      <SimpleForm>
        <LocationFormContent />
      </SimpleForm>
    </Create>
  );
};
export default LocationCreate;
